import { useGetPurchase } from 'api-hooks/tour/tour-list/purchase/query';
import { CloseSVG } from 'common/assets';
import stylesColors from 'common/styles/styles.colors';
import {
  DrawerBody,
  DrawerFooter,
  DrawerHeaderContainer,
  DrawerLeftContainer,
  DrawerRightContainer,
} from 'components/common/drawer/styles';
import { Pagination } from 'components/elements/pagination-component';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import Text from 'components/elements/text';
import { Action } from 'components/styles';
import { FooterDivider } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import ExportToExcel from '../export-to-excel';

interface Props {
  id: string;
  onClose: () => void;
}

export default function ListPurchasePanel(props: Props) {
  const { t } = useTranslation();
  const { id, onClose } = props;
  const [page, setPage] = React.useState<number>(1);

  const { data, isFetching } = useGetPurchase({
    id,
    params: { page, limit: -1 },
  });
  const items = data?.data || [];

  const _columns = React.useMemo<IColumn<any>[]>(
    () => [
      {
        header: t('common:order_no'),
        accessorKey: 'number',
        minSize: 200,
        size: 200,
      },
      {
        header: t('common:type'),
        accessorKey: 'type',
        minSize: 100,
        size: 100,
      },
      {
        header: t('common:agent'),
        accessorKey: 'agent',
        minSize: 200,
        size: 200,
      },
    ],
    [t],
  );

  const showExport = !isFetching && items.length > 0;

  return (
    <>
      <DrawerHeaderContainer>
        <DrawerLeftContainer>
          <Text variant="title3Bold">{t('common:purchase_list')}</Text>
        </DrawerLeftContainer>
        <DrawerRightContainer>
          <ExportToExcel
            data={items}
            filename={`purchase-list-${id}`}
            buttonProps={{
              isLoading: isFetching,
              disabled: !showExport,
            }}
          />
          <Action onClick={onClose}>
            <CloseSVG />
          </Action>
        </DrawerRightContainer>
      </DrawerHeaderContainer>
      <DrawerBody>
        <TableComponent
          data={data?.data || []}
          headerColor={stylesColors.bg1}
          columns={_columns}
          isLoading={isFetching}
        />
        <FooterDivider />

        <DrawerFooter $style={{ justifyContent: 'center' }}>
          <Pagination
            currentPage={page}
            onPageChange={setPage}
            numPages={data?.meta?.lastPage || 0}
          />
        </DrawerFooter>
      </DrawerBody>
    </>
  );
}
